import React, {useEffect, useState} from 'react';
import {
    AppBar,
    Box,
    Button,
    CardActions,
    CardHeader,
    Collapse,
    Divider,
    IconButton,
    Stack,
    Typography
} from "@mui/material";
import Card from "@mui/material/Card";
import useAuth from "../../hooks/useAuth";
import localStrings from "../../localStrings";
import {getFilterStartDateFormatted} from "../../utils/FilterHelper";
import FilterEditor from "../../layouts/dashboard/Filter/FilterEditor";
import CardContent from "@mui/material/CardContent";
import {styled} from "@mui/styles";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const filterYesterday = "filterYesterday";
export const filterCurrentWeek= "filterCurrentWeek";
export const filterWeek= "filterWeek";
export const filterCurrentMonth= "filterCurrentMonth";
export const filterMonth= "filterMonth";
export const filterCurrentYear= "filterCurrentYear";
export const filterYear= "filterYear";
export const filterSingleDay= "filterSingleDay";
export const filterPersonalysePeriod= "filterPersonalysePeriod";

export const allFilters = [
    {
        value: filterSingleDay,
        label: localStrings.filterSingleDay
    },
    {
        value: filterWeek,
        label: localStrings.filterWeek
    },
    {
        value: filterMonth,
        label: localStrings.filterMonth
    },
    {
        value: filterYear,
        label: localStrings.filterYear
    },
    // {
    //     value: filterPersonalysePeriod,
    //     label: localStrings.filterPersonalysePeriod
    // },

];

function FilterInfoOverview({setOpen}) {
    const {filter, setFilter} = useAuth()
    const [expanded, setExpanded] = React.useState(false);

    const ExpandMore = styled((props) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));

    function setFilterType(filterType) {
        setFilter({
            ...filter,
            filterType: filterType
        })

        if (
            filterType !== filterSingleDay &&
            filterType !== filterPersonalysePeriod
        ) {
            setOpen(false)
        }
    }

    return (

        <div
            style={{
                width: '100%',
                position: 'sticky',
                top: 50,
                zIndex: 1000,
            }}
        >

            <Card>
                <CardContent>

                    <Stack
                        alignItems="center"
                        direction={{
                            xs: 'column',
                            sm: 'column'
                        }}
                        spacing={3}
                        sx={{
                            px: 4,
                            py: 3
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                            }}
                        >

                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    p: 1,
                                    m: 1,
                                    flexWrap: 'wrap',
                                }}
                            >
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterYesterday ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterYesterday)}
                                    >
                                        {localStrings.filterYesterday}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterCurrentWeek ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterCurrentWeek)}
                                    >
                                        {localStrings.filterCurrentWeek}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterWeek ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterWeek)}
                                    >
                                        {localStrings.filterLastWeek}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterCurrentMonth ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterCurrentMonth)}
                                    >
                                        {localStrings.filterCurrentMonth}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterMonth ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterMonth)}
                                    >
                                        {localStrings.filterLastMonth}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterCurrentYear ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterCurrentYear)}
                                    >
                                        {localStrings.filterCurrentYear}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterYear ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterYear)}
                                    >
                                        {localStrings.filterLastYear}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterSingleDay ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterSingleDay)}
                                    >
                                        {localStrings.filterSingleDay}
                                    </Button>
                                </Box>
                                <Box m={1}>
                                    <Button
                                        variant={filter?.filterType === filterPersonalysePeriod ? "contained" : "outlined"}
                                        onClick={() => setFilterType(filterPersonalysePeriod)}
                                    >
                                        {localStrings.filterPersonalysePeriod}
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                        <FilterEditor setOpen={setOpen}/>
                    </Stack>

                </CardContent>
            </Card>
        </div>
    )
}

export default FilterInfoOverview